/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_CHE_CALENDAR_ITEM = {
  id: 'checks_sidebar_calendar',
  screenId: 'fin-che-calendar',
  label: 'Calendario',
  description: 'Vencimientos de cheques emitidos.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Planificá pagos viendo en una grilla de 30 días qué cheques propios vencen cada día y cuánto tenés que desembolsar.',
      },
      {
        title: 'Cómo usarlo',
        fields: [
          {
            label: 'Primer día del calendario',
            description: 'Elegí desde qué fecha arranca la vista (por defecto ayer). Se muestran 30 días seguidos.',
          },
        ],
        bullets: [
          'Arriba ves totales: a vencer, pagados, cobrados por ventanilla, rechazados y no aceptados.',
          'Cada día muestra fecha, importe total y lista de cheques (número, proveedor, banco emisor, monto).',
          'El día de hoy se resalta. Los importes cambian de color según el estado del cheque.',
          'Los días vacíos indican «Sin cheques».',
        ],
      },
    ],
  },
}
